// Which alarms still need a shout. An acknowledged alarm is "seen, working on it": it stays on the
// Health page (with who acknowledged it and when) but leaves the red bar and the nav dot.
// Browser-safe, no dependencies.

export interface AlarmVisibility {
  acknowledged_at: string | Date | null | undefined;
  resolved_at: string | Date | null | undefined;
}

/** open AND not yet acknowledged: the ones the red bar and the nav dot show */
export function isShouting(alarm: AlarmVisibility): boolean {
  return !alarm.resolved_at && !alarm.acknowledged_at;
}

/** the subset of a health list that the app shell's red bar shows, order kept */
export function shoutingAlarms<T extends AlarmVisibility>(alarms: readonly T[] | null | undefined): T[] {
  return (alarms ?? []).filter(isShouting);
}
